import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, ArrowLeft, Users, Palette } from "lucide-react";

export default function WelcomeChoice() {
  const [open, setOpen] = useState(() => !sessionStorage.getItem("welcome_choice_seen"));
  const navigate = useNavigate();

  const dismiss = () => {
    sessionStorage.setItem("welcome_choice_seen", "1");
    setOpen(false);
  };

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && dismiss();
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[120] flex items-center justify-center px-5"
         style={{ background: "rgba(38,32,22,0.55)", backdropFilter: "blur(14px)", WebkitBackdropFilter: "blur(14px)" }}
         onClick={dismiss} data-testid="welcome-popup">
      <div onClick={(e) => e.stopPropagation()}
           className="w-full max-w-xl rounded-3xl overflow-hidden shadow-2xl"
           style={{ background: "#EDE7D9", border: "1px solid rgba(181,121,63,0.5)", animation: "wc-pop .45s cubic-bezier(.22,1,.36,1) both" }}>
        <button onClick={() => { dismiss(); navigate("/tribe"); }} data-testid="welcome-tribe-btn"
                className="group w-full flex items-center gap-5 px-8 md:px-10 py-8 md:py-10 text-left transition-colors"
                style={{ background: "linear-gradient(135deg, #262016 0%, #3B301F 100%)" }}>
          <Users className="shrink-0 text-[#B5793F]" size={26} strokeWidth={1.6} />
          <span className="flex-1 min-w-0">
            <span className="rp-display block text-2xl md:text-3xl font-medium text-[#F6F1E5]">Enter my Tribe</span>
            <span className="block text-sm text-[#CBBFA8] mt-1" style={{ textWrap: "pretty" }}>
              Useful reels, updates, downloads, games &amp; an unique adaptive learning experience.
            </span>
          </span>
          <ArrowRight className="shrink-0 text-[#B5793F] transition-transform group-hover:translate-x-1.5" size={30} strokeWidth={2} />
        </button>

        <button onClick={dismiss} data-testid="welcome-portfolio-btn"
                className="group w-full flex items-center gap-5 px-8 md:px-10 py-8 md:py-10 text-left transition-colors hover:bg-white/60"
                style={{ background: "rgba(255,255,255,0.45)", borderTop: "1px solid rgba(38,32,22,0.15)" }}>
          <ArrowLeft className="shrink-0 text-[#B5793F] transition-transform group-hover:-translate-x-1.5" size={30} strokeWidth={2} />
          <span className="flex-1 min-w-0">
            <span className="rp-display block text-2xl md:text-3xl font-medium text-[#262016]">Check my portfolio</span>
            <span className="block text-sm text-[#5C5042] mt-1" style={{ textWrap: "pretty" }}>
              Design work, AI projects, growth stories &amp; experience
            </span>
          </span>
          <Palette className="shrink-0 text-[#B5793F]" size={26} strokeWidth={1.6} />
        </button>
      </div>
      <style>{`@keyframes wc-pop { from { opacity: 0; transform: translateY(26px) scale(.96); } to { opacity: 1; transform: none; } }`}</style>
    </div>
  );
}
